import { DocumentationAreaId } from "src/contexts/documentationArea/domain/DocumentationAreaId";
import { ActorId } from "src/contexts/documentationArea/domain/ActorId";
import { TranslationRepository } from "src/contexts/translation/domain/TranslationRepository";

export class StaticTranslationRepository implements TranslationRepository {
  public getTranslations = async (locale: string, _: string) => {
    const fileReader = new FileReader();
    const file = await fetch(`locales/` + locale + `.json`).then((response) => response.blob());
    const data = await new Promise<string>((resolve, reject) => {
      fileReader.onload = () => resolve(fileReader.result as string);
      fileReader.onerror = () => reject(new Error("Error reading file"));
      fileReader.readAsText(file);
    });
    const jsonObject = JSON.parse(data);
    if (typeof jsonObject === "object" && jsonObject !== null) {
      return jsonObject;
    }

    console.error("Error reading translations JSON file");
    return {};
  };

  public getTranslationsByDocumentationAreaId = async (locale: string, _: DocumentationAreaId) => {
    return this.getTranslations(locale, _);
  };

  public getLocaleConfig = async (_: string) => {
    return { availableLocales: ["en", "es", "ca", "eu", "pt"], resolvedLocale: "ca" };
  };

  public getLocaleConfigByDocumentationAreaId = async (_: DocumentationAreaId, __: ActorId) => {
    return this.getLocaleConfig(_);
  };
}
